import React from 'react';

import {
  SVG,
} from 'web-styled';

import * as S from './styled';

type Props = {
  src?: string,
  width?: string,
  height?: string,
  bgColor?: string,
  className?: string,
  placeholderSize?: number | string,
  placeholderColor?: string,
};

const Avatar = ({
  src,
  width,
  height,
  bgColor,
  className,
  placeholderSize,
  placeholderColor,
}: Props) => (
  <S.AvatarWrapper
    width={width}
    height={height}
    bgColor={bgColor}
    className={className}
  >
    {src ? (
      <S.Avatar
        style={{
          backgroundImage: `url(${src})`,
        }}
      />
    ) : (
      <SVG.Avatar
        width={placeholderSize}
        fill={placeholderColor}
      />
    )}
  </S.AvatarWrapper>
);

Avatar.defaultProps = {
  src: null,
  width: '130px',
  height: '130px',
  placeholderSize: 18,
  placeholderColor: '#fff',
  bgColor: '#eee',
  className: null,
};

export default Avatar;
